import { Layout } from "@/components/layout/Layout";
import { SEO } from "@/components/SEO";

const Privacy = () => {
  return (
    <Layout>
      <SEO 
        title="Privacy Policy | Bookkeeping Services South Africa"
        description="Our privacy policy outlines how we protect your personal information in accordance with POPIA. Learn about your data rights and our security measures."
        canonical="/privacy"
      />
      <section className="py-16 lg:py-24 section-accent">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-6">
              Privacy Policy
            </h1>
            <p className="text-lg text-muted-foreground">
              Last updated: January 2026
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-24 section-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto prose prose-slate">
            <div className="space-y-8">
              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  POPIA Compliance
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Bookkeeping Services South Africa is committed to protecting your personal 
                  information in accordance with the Protection of Personal Information Act 
                  (POPIA) of South Africa. This policy outlines how we collect, use, and 
                  protect your data.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Information We Collect
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  We collect information that you provide directly to us, including:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Contact information (name, email, phone number)</li>
                  <li>Business information (company name, registration details)</li>
                  <li>Financial records necessary for bookkeeping services</li>
                  <li>Employee information for payroll services</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  How We Use Your Information
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Your information is used exclusively for:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Providing bookkeeping and accounting services</li>
                  <li>Communicating about your services</li>
                  <li>Compliance with SARS and other regulatory requirements</li>
                  <li>Improving our services</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Data Security
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  We implement appropriate technical and organizational measures to protect 
                  your personal information against unauthorized access, alteration, 
                  disclosure, or destruction. All financial data is handled with strict 
                  confidentiality.
                </p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Your Rights
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Under POPIA, you have the right to:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Access your personal information</li>
                  <li>Request correction of inaccurate information</li>
                  <li>Request deletion of your information</li>
                  <li>Object to processing of your information</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">
                  Contact Us
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  For any privacy-related queries, please contact us at:{" "}
                  <a href="mailto:info@bookkeepingservices.co.za" className="text-primary hover:underline">
                    info@bookkeepingservices.co.za
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Privacy;
